import * as React from "react";
import StandardPage from "../components/standard-page";
import NavHeader from "../components/nav-header";
import PostCard from "../components/post-card";
import { graphql } from "gatsby";
import BannerGallery from "../components/banner-gallery";
import Seo from "../components/seo";

// markup
export default function Home({ data }) {
  const posts = data.home.childContentYaml.home.map((link) => link.post);
  return (
    <StandardPage
      header={
        <NavHeader>
          <BannerGallery tileImage={data.tile} featureImage={data.feature} />
        </NavHeader>
      }
    >
      <div className="container w-full md:max-w-6xl mx-auto pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-6 md:px-8 my-8">
          {posts.map((post) => (
            <PostCard className="h-auto" key={post.id} post={post} />
          ))}
        </div>
      </div>

      <Seo
        title="Lost with Lydia"
        description="Texas based travel blogger sharing tips for outdoor destinations and cities around the world. Maximize your PTO and take short but meaningful trips."
        cover={data.feature}
        slug="/"
        type={false}
      />
    </StandardPage>
  );
}

export const pageQuery = graphql`
  query {
    home: file(relativePath: { eq: "highlights.yml" }) {
      childContentYaml {
        home {
          post {
            headings {
              value
            }
            frontmatter {
              title
              categories
              date
              banner {
                publicURL
                childImageSharp {
                  gatsbyImageData(width: 400)
                }
              }
            }
            fields {
              slug
            }
            id
          }
        }
      }
    }
    feature: file(relativePath: { eq: "cathedral.jpg" }) {
      publicURL
      childImageSharp {
        gatsbyImageData(width: 900, layout: FULL_WIDTH)
      }
    }
    tile: file(relativePath: { eq: "cactus.png" }) {
      childImageSharp {
        fixed(width: 200) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;
